import React from "react";
import "./CommonTable.css";

/**
 * columns: [{ key: "name", label: "병원명" }, { key: "date", label: "연동 날짜" }, { key: "action", label: "연동 해지", isButton: true }]
 * data: [{ name: "서울메디컬센터", date: "2024-08-01" }, ...]
 */
function CommonTable({ columns = [], data = [], onButtonClick }) {
  return (
    <table className="common-table">
      <thead>
        <tr>
          {columns.map((col) => (
            <th key={col.key}>{col.label}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.length > 0 ? (
          data.map((row, idx) => (
            <tr key={idx}>
              {columns.map((col) => (
                <td key={col.key} style={{ textAlign: col.textAlign || "left" }}>
                  {col.render ? (
                    col.render(row)
                  ) : col.isButton ? (
                    <button onClick={() => onButtonClick && onButtonClick(row)} {...(col.buttonProps || {})}>
                      {col.buttonLabel || "버튼"}
                    </button>
                  ) : (
                    row[col.key] ?? "-"
                  )}
                </td>
              ))}
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={columns.length} style={{ textAlign: "center", padding: "10px" }}>
              데이터가 없습니다.
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

export default CommonTable;
